import { i18n } from '@/i18n';
import { currentSiteName } from '@/utils/tools';

const { t } = i18n.global;
export default [
  {
    path: '/',
    component: () => import('@/layouts/DefaultLayout/index.vue'),
    children: [
      {
        path: '404',
        name: '404',
        component: () => import('@/views/ErrorPage/index.vue'),
        meta: {
          title: `${currentSiteName()} - ${t('page.t.opeSouComOfGloDev')}}`,
          hasMobile: true
        }
      },
      {
        path: '403',
        name: '403',
        component: () => import('@/views/ErrorPage/index.vue'),
        meta: {
          title: '403',
          hasMobile: true
        }
      },
      {
        path: '451',
        name: '451',
        component: () => import('@/views/ErrorPage/index.vue'),
        meta: {
          title: '待审核',
          errorCode: '451',
          hasMobile: true
        }
      },
      {
        path: '503',
        name: '503',
        component: () => import('@/views/ErrorPage/index.vue'),
        meta: {
          title: '503',
          hasMobile: true
        }
      },
      {
        path: 'download-error',
        name: 'error',
        component: () => import('@/views/ErrorPage/index.vue'),
        meta: {
          title: 'error',
          hasMobile: true
        }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/layouts/DefaultLayout/index.vue'),
    children: [
      {
        path: '',
        name: 'notFound',
        component: () => import('@/views/ErrorPage/index.vue'),
        meta: {
          title: `${currentSiteName()} - ${t('page.t.opeSouComOfGloDev')}}`,
          hasMobile: true
        }
      }
    ]
  }
];
